export const removeSpaces = (str: string) => str.replace(/\s+/g, '');

export const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
